namespace Nobox.Administration {
    export interface SettingUserForm {
        Username: Serenity.StringEditor;
        DisplayName: Serenity.StringEditor;
        Email: Serenity.EmailAddressEditor;
        MobilePhoneNumber: Serenity.StringEditor;
        Timezone: Serenity.ServiceLookupEditor;
        TenantId: Serenity.ServiceLookupEditor;
        UserImage: Serenity.ImageUploadEditor;
        CtryId: Serenity.ServiceLookupEditor;
        StatesId: Serenity.ServiceLookupEditor;
        CityId: Serenity.ServiceLookupEditor;
        FormatDate: FormatDateEditor;
        CustomDate: Serenity.StringEditor;
        DisplayDate: Serenity.StringEditor;
        FormatTime: FormatTimeEditor;
        CustomTime: Serenity.StringEditor;
        DisplayTime: Serenity.StringEditor;
        FormatNumber: Serenity.StringEditor;
        aDec: AdecEditor;
        mDec: Serenity.IntegerEditor;
        aSep: AsepEditor;
        dGroup: DgroupEditor;
        lZero: LzeroEditor;
        DisplayNumber: Serenity.StringEditor;
        Currencies: CurrencyEditor;
        CurrenciesPlace: CurrenciesPlaceEditor;
        Ctry: Serenity.StringEditor;
        States: Serenity.StringEditor;
        City: Serenity.StringEditor;
    }

    export class SettingUserForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.SettingUserForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SettingUserForm.init)  {
                SettingUserForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EmailAddressEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = s.ImageUploadEditor;
                var w4 = FormatDateEditor;
                var w5 = FormatTimeEditor;
                var w6 = AdecEditor;
                var w7 = s.IntegerEditor;
                var w8 = AsepEditor;
                var w9 = DgroupEditor;
                var w10 = LzeroEditor;
                var w11 = CurrencyEditor;
                var w12 = CurrenciesPlaceEditor;

                Q.initFormType(SettingUserForm, [
                    'Username', w0,
                    'DisplayName', w0,
                    'Email', w1,
                    'MobilePhoneNumber', w0,
                    'Timezone', w2,
                    'TenantId', w2,
                    'UserImage', w3,
                    'CtryId', w2,
                    'StatesId', w2,
                    'CityId', w2,
                    'FormatDate', w4,
                    'CustomDate', w0,
                    'DisplayDate', w0,
                    'FormatTime', w5,
                    'CustomTime', w0,
                    'DisplayTime', w0,
                    'FormatNumber', w0,
                    'aDec', w6,
                    'mDec', w7,
                    'aSep', w8,
                    'dGroup', w9,
                    'lZero', w10,
                    'DisplayNumber', w0,
                    'Currencies', w11,
                    'CurrenciesPlace', w12,
                    'Ctry', w0,
                    'States', w0,
                    'City', w0
                ]);
            }
        }
    }
}
